<template>
  <v-dialog v-model="dialog" :persistent="dialog" max-width="500">
    <v-card>
      <v-card-title primary-title>
        <h4>
          {{ $t("general.change_password_dialog") }} <b>{{ user.name }}</b>
        </h4>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="password"
          v-validate="'required'"
          data-vv-name="password"
          required
          :error-messages="errors.collect('password')"
          :label="$t('profile.password.new')"
          :type="passwordFieldType"
          append-icon="visibility"
          @click:append="togglePasswordVisibility"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">
          {{ $t("general.close") }}
        </v-btn>
        <v-btn text @click="save">
          {{ $t("general.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog", "user"],
  watch: {
    dialog() {
      this.password = "";
    }
  },
  data() {
    return {
      password: "",
      passwordFieldType: "password" // Add this data property
    };
  },
  methods: {
    async save() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        this.$emit("save", {
          id: this.user.id,
          email: this.user.email,
          password: this.password
        });
      }
    },
    close() {
      this.$emit("close");
    },
    togglePasswordVisibility() {
      // Toggle between 'password' and 'text' for input type
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    }
  }
};
</script>

<style></style>
